
import React, { useState, useEffect } from 'react';
import { message, Button } from 'antd';
import axios from 'axios';
import * as XLSX from 'xlsx';
import useAuth from '../hooks/useAuth';

const URL = process.env.REACT_APP_API_URL;
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;

const BulkUpload = () => {

    const [fileList, setFileList] = useState();
    const [uploadedFile, setUploadedFile] = useState();
    const [errorMessagesState, setErrorMessagesState] = useState([]);
    const [validRowsState, setvalidRowsState] = useState([]);
    const [meetLink, setMeetLink] = useState('');
    const [meetingData, setMeetingData] = useState('');
    // const [tokenClient, setTokenClient] = useState(null);
    const { accessToken, setAccessToken } = useAuth();

    // const tokenClient = window.google.accounts.oauth2.initTokenClient({
    //     client_id: CLIENT_ID,
    //     scope: "https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/userinfo.email",
    //     callback: (resp) => {
    //         if (resp.error) {
    //             console.error('Token Request Error: ', resp)
    //         }
    //         console.log("Access Token: ", resp.access_token);
    //         setAccessToken(resp.access_token);
    //         // console.log('after assigning accessToken: ', accessToken);
    //     }
    // });

    // useEffect(() => {
    //     if (!window.google?.accounts?.oauth2) {
    //         console.warn("Google Identity Services not loaded yet.");
    //         return;
    //     }

    //     const client = window.google.accounts.oauth2.initTokenClient({
    //         client_id: CLIENT_ID,
    //         scope: [
    //             "https://www.googleapis.com/auth/calendar.events",
    //             "https://www.googleapis.com/auth/gmail.readonly",
    //             "https://www.googleapis.com/auth/userinfo.email"
    //         ],
    //         callback: (resp) => setAccessToken(resp.access_token),
    //     });

    //     setTokenClient(client);
    // }, []);


    // useEffect(() => {
    //     let script = document.getElementById("gis-script");

    //     const initializeClient = () => {
    //         if (window.google?.accounts?.oauth2) {
    //             const client = window.google.accounts.oauth2.initTokenClient({
    //                 client_id: CLIENT_ID,
    //                 scope: [
    //                     "https://www.googleapis.com/auth/calendar.events",
    //                     "https://www.googleapis.com/auth/gmail.readonly",
    //                     "https://www.googleapis.com/auth/userinfo.email"
    //                 ],
    //                 callback: (resp) => {
    //                     if (resp.error) console.error('Token Request Error: ', resp);
    //                     else setAccessToken(resp.access_token);
    //                 }
    //             });
    //             setTokenClient(client);
    //         }
    //     };

    //     if (!script) {
    //         script = document.createElement("script");
    //         script.src = "https://accounts.google.com/gsi/client";
    //         script.id = "gis-script";
    //         script.async = true;
    //         script.defer = true;
    //         script.onload = initializeClient;
    //         document.body.appendChild(script);
    //     } else {
    //         // Script already exists — just initialize the client
    //         initializeClient();
    //         // setTimeout(initializeClient, 500);
    //     }
    // }, []);


    // useEffect(() => {
    //     if (document.getElementById("gis-script")) return;

    //     const script = document.createElement("script");
    //     script.src = "https://accounts.google.com/gsi/client";
    //     script.id = "gis-script";
    //     script.async = true;
    //     script.defer = true;
    //     // script.crossOrigin = 'use-credentials';
    //     script.onload = () => {
    //         const client = window.google.accounts.oauth2.initTokenClient({
    //             client_id: CLIENT_ID,
    //             scope: [
    //                 "https://www.googleapis.com/auth/calendar.events",
    //                 "https://www.googleapis.com/auth/gmail.readonly",
    //                 "https://www.googleapis.com/auth/userinfo.email"
    //             ],
    //             callback: (resp) => {
    //                 if (resp.error) {
    //                     console.error('Token Request Error: ', resp)
    //                 }
    //                 console.log("Access Token: ", resp.access_token);
    //                 setAccessToken(resp.access_token);
    //                 // console.log('after assigning accessToken: ', accessToken);
    //             }
    //         });
    //         setTokenClient(client);
    //     }
    //     console.log('script is loaded.');

    //     document.body.appendChild(script);
    // }, []);

    // useEffect(() => {
    //     console.log('tokenClient created: ', tokenClient);
    //     console.log('access token check: ', accessToken);
    // }, [tokenClient, accessToken])


    // const client = window.google.accounts.oauth2.initTokenClient({
    //     client_id: CLIENT_ID,
    //     scope: [
    //         "https://www.googleapis.com/auth/calendar.events",
    //         "https://www.googleapis.com/auth/gmail.readonly",
    //         "https://www.googleapis.com/auth/userinfo.email"
    //     ],
    //     callback: (resp) => {
    //         if (resp.error) {
    //             console.error('Token Request Error: ', resp)
    //         }
    //         console.log("Access Token: ", resp.access_token);
    //         setAccessToken(resp.access_token);
    //         // console.log('after assigning accessToken: ', accessToken);
    //     }
    // });

    const handleChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];

            const isValidType =
                file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                file.type === 'text/csv';

            if (!isValidType) {
                message.error(`${file.name} is not a valid file. Please upload .xlsx or .csv files.`);
                setUploadedFile(null);
                return;
            }

            // Read the file
            const reader = new FileReader();
            reader.readAsArrayBuffer(file);

            reader.onload = (event) => {
                const data = new Uint8Array(event.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];

                // Convert to JSON
                const jsonData = XLSX.utils.sheet_to_json(sheet, {raw: false});
                console.log('jsonData', jsonData);

                // Validate headers
                const requiredHeaders = ["Sr No*", "Candidate Name*", "Mobile Number*", "Email ID*"];
                console.log('requiredHeaders', requiredHeaders);

                const fileHeaders = Object.keys(jsonData[0] || {});
                console.log('fileHeaders', fileHeaders);

                const missingHeaders = requiredHeaders.filter(header => !fileHeaders.includes(header));
                console.log('missingHeaders', missingHeaders);

                if (missingHeaders.length > 0) {
                    message.error(`Missing required columns: ${missingHeaders.join(', ')}`);
                    return;
                }

                // Validate Data
                const srNoRegex = /^[0-9]+$/;
                const nameRegex = /^[A-Za-z\s]+$/;
                // const jobIdRegex = /^[A-Za-z]+-[A-Z]{2}-\d{5}$/;
                // const jobIdRegex = /^[A-Za-z]+-[A-Z]{1,3}-[A-Z]{0,3}-\d{5}$/;
                const jobIdRegex = /^[A-Za-z]+-[A-Z]{1,4}(?:-[A-Za-z0-9]+)?-\d{5}$/;
                const emailRegex = /^[a-zA-Z0-9._%+-]+@(?!enfuse-solutions\.com$)[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;
                const contactRegex = /^[0-9]{10}$/;
                // const experienceRegex = /^(30(\.0{1,2})?|[0-2]?[0-9](\.\d{1,2})?)$/;
                const experienceRegex = /^\d+(\.\d{1,2})?$/;
                const designationRegex = /^[A-Za-z\s]+$/;
                const hrNameRegex = /^[A-Za-z\s]+$/;
                const isCampusDriveRegex = /^(Yes|yes|No|no)$/;

                let errorMessages = [];
                let validRows = [];
                let invalidRows = [];
                let count = 0;
                let validRecordsCount = 0;

                jsonData.forEach((row, index) => {
                    let isValid = true;
                    let errors = []

                    if (!row.password || !row.confirmPassword) {
                        row.password = Math.random().toString(36).slice(-8);
                        row.confirmPassword = row.password;
                    }
                     if(row["Date Of Joining"]){
                        row["Date Of Joining"] = String(row["Date Of Joining"])
                    }

                    if (!row["Sr No*"] || !srNoRegex.test(row["Sr No*"])) {
                        errors.push(`Invalid Sr No`);
                        isValid = false;
                    }
                    
                    if (!row["Candidate Name*"] || !nameRegex.test(row["Candidate Name*"])) {
                        errors.push(`Invalid Candiadate Name`);
                        isValid = false;
                    }
                    if (!row["Job ID*"] || !jobIdRegex.test(row["Job ID*"])) {
                        errors.push(`Invalid Job ID`);
                        isValid = false;
                    }
                    if (!row["Mobile Number*"] || !contactRegex.test(row["Mobile Number*"])) {
                        errors.push(`Invalid Mobile Number`);
                        isValid = false;
                    }
                    if (!row["Email ID*"] || !emailRegex.test(row["Email ID*"])) {
                        errors.push(`Invalid Email`);
                        isValid = false;
                    }
                    if (!row["Role/Designation*"] || !designationRegex.test(row["Role/Designation*"])) {
                        errors.push(`Invalid Designation`);
                        isValid = false;
                    }
                    if ((row["Total Experience*"] ?? "") ===""  || !experienceRegex.test(row["Total Experience*"])) {
                        errors.push(`Invalid Total Experience. Experience field should only contain numbers or decimals.`);
                        isValid = false;
                    }
                    if ((row["Total Experience*"] ?? "") ==="" || !experienceRegex.test(row["Relevant Experience*"])) {
                        errors.push(`Invalid Relevant Experience. Experience field should only contain numbers or decimals.`);
                        isValid = false;
                    }
                    if (!row["HR Name*"] || !hrNameRegex.test(row["HR Name*"])) {
                        errors.push(`Invalid HR Name`);
                        isValid = false;
                    }
                    if (!row["IsCampusDrive(Yes/No)*"] || !isCampusDriveRegex.test(row["IsCampusDrive(Yes/No)*"])) {
                        errors.push(`Invalid Input for 'Is Campus Drive Field'`);
                        isValid = false;
                    }

                    if (isValid) {
                        validRows.push(row);
                        validRecordsCount++;
                    }
                    else {
                        invalidRows.push(row);
                        count++;
                        // errorMessages.push(errors);
                    }

                    if (errors && errors.length > 0) {
                        errorMessages.push(`Row ${index + 2}: ${errors.join(', ')}`);
                        // console.log('row with error: ', row);
                    } else {
                        setErrorMessagesState([]);
                    }
                });

                if (errorMessages && errorMessages.length > 0) {
                    setErrorMessagesState(errorMessages);
                    message.warning(`${count} records have errors and were not included.`);
                } else {
                    setErrorMessagesState(null);
                }

                console.log("Valid Rows:", validRows);
                console.log("Invalid Rows:", invalidRows);

                if (validRows.length > 0) {
                    setvalidRowsState(validRows); // Store only valid rows
                    message.success(`${validRecordsCount} Valid records can be uploaded!`);
                } else {
                    message.error("No valid records found in the file.");
                    setvalidRowsState(null);
                }
            };

            reader.onerror = () => {
                message.error("Error reading file. Please try again.");
            };

        } else {
            console.log('File selection canceled.');
            setvalidRowsState(null);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validRowsState || validRowsState.length === 0) {
            message.error('No file uploaded. Please upload a file with valid rows!');
            return;
        }

        // Filter candidates who meet the criteria
        const shortlistedCandidates = validRowsState.filter(candidate =>
            // (candidate["IsCampusDrive(Yes/No)"] === 'Yes' || candidate["IsCampusDrive(Yes/No)"] === 'yes') &&
            candidate['Candidate Final Status'] === 'CV Shortlisted'
        );

        // console.log('shortlistedCandidates: ', shortlistedCandidates);

        try {
            const response = await axios.post(`${URL}/api/bulkupload`, { validRows: validRowsState }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            // console.log('Response:', response.data);
            message.success(`${validRowsState.length} Valid Records Uploaded Successfully.`);
            // console.log('Uploaded rows handleSubmit:', validRowsState);

            // If there are candidates to notify, send emails
            if (shortlistedCandidates.length > 0) {
                await axios.post(`${URL}/api/user/credentials`, { candidates: shortlistedCandidates }, {
                    headers: { 'Content-Type': 'application/json' }
                });

                message.success(`${shortlistedCandidates.length} shortlisted candidates notified successfully.`);
            } else {
                message.info('No shortlisted candidates required an email notification.');
            }

        } catch (error) {
            console.error('Error uploading file:', error);
            console.error('Error uploading file or sending emails:', error);
            message.error('An error occurred during file upload or email notification.');
        }
    }

    const handleDownloadTemplate = () => {
        // console.log('Download Template.');

        const headers = [
            "Sr No*", "Candidate Name*", "Job ID*", "Mobile Number*", "Email ID*", "Organisation",
            "Role/Designation*", "Total Experience*", "Relevant Experience*", "Education", "Salary",
            "Expected Salary", "Notice Period/ LWD", "Current Location", "Prefered Location",
            "Resume Status", "Test Applicability", "Test Status", "Test Score",
            "L1 Interviewer", "L1 Interview Status", "L2 Interviewer", "L2 Interview Status",
            "L3 Interviewer", "L3 Interview Status", "IsCampusDrive(Yes/No)*", "Candidate Final Status",
            "HR Comments", "HR Name*", "Resume Link", "Date Of Joining"
        ];

        // Create a worksheet with just the headers
        const worksheet = XLSX.utils.aoa_to_sheet([headers]);

        // Create a workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "template");

        // Write the file and trigger download
        XLSX.writeFile(workbook, "Candidate_Template.xlsx");
    }


    const handleGetMeetingData = async () => {
        if (!accessToken) {
            message.error("Please connect your Google Account first.");
            return;
        }

        if (!meetLink) {
            message.error("Please enter the meeting link first.");
            return;
        }

        try {
            // Step 1: Search Gmail for the transcribed email
            const searchQuery = `from:meetings-noreply@google.com "${meetLink}"`;
            const searchResponse = await fetch(
                `https://gmail.googleapis.com/gmail/v1/users/me/messages?q=${encodeURIComponent(searchQuery)}`,
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }
            );

            console.log('searchResponse: ', searchResponse);

            const searchData = await searchResponse.text();
            console.log('searchData: ', searchData);

            if (!searchData.messages || searchData.messages.length === 0) {
                message.error("No transcription email found for this meeting link.");
                return;
            }

            // Step 2: Fetch the latest email (most recent one)
            const messageId = searchData.messages[0].id;
            const messageResponse = await fetch(
                `https://gmail.googleapis.com/gmail/v1/users/me/messages/${messageId}`,
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }
            );
            const messageData = await messageResponse.json();

            // Step 3: Extract and decode the email body
            let body = "";
            const parts = messageData.payload.parts || [];

            // Gmail messages can have multiple MIME parts
            for (const part of parts) {
                if (part.mimeType === "text/plain" && part.body.data) {
                    body = atob(part.body.data.replace(/-/g, "+").replace(/_/g, "/"));
                    break;
                } else if (part.mimeType === "text/html" && part.body.data) {
                    body = atob(part.body.data.replace(/-/g, "+").replace(/_/g, "/"));
                    break;
                }
            }

            // Step 4: Clean HTML if needed
            const cleanBody = body.replace(/<[^>]+>/g, ""); // remove HTML tags if any

            // Step 5: Fill the textarea
            setMeetingData(cleanBody || "No transcription text found in email.");

        } catch (error) {
            console.error("Error fetching meeting data:", error);
            message.error("Something went wrong while fetching the transcription.");
        }
    };


    return (
        <>
            <div className='fetch-table' style={{ marginTop: '70px', marginLeft: '15px', borderRadius: '8px', width: '97.5%' }} >
                <div style={{ backgroundColor: 'white', padding: '20px' }}>
                    <p style={{ fontSize: '20px', color: 'black', fontWeight: 'bolder', marginLeft: '30%' }}>Upload excel in the bulk below </p>
                    <br />
                    <form>
                        <div style={{ marginLeft: '30%' }}>
                            <input style={{ fontSize: '19px', alignItems: 'center', backgroundColor: 'white', border: '1px solid', marginBottom: '5px', borderRadius: '6px' }} name='bulkUploadFile' type="file" required onChange={handleChange} accept=".xlsx, .csv" placeholder=".xlsx, .csv" ></input>
                        </div>
                        <div style={{ width: '300px', marginLeft: '32.5%', display: 'flex', justifyContent: 'center' }}>
                            <Button type="submit" className="form-btn" onClick={handleSubmit}>
                                Submit
                            </Button>
                            <Button type="button" className="form-btn" style={{ backgroundColor: '#1a2763' }} onClick={handleDownloadTemplate}>
                                Download Template
                            </Button>
                        </div>
                    </form>
                    <br />
                    <div>
                        <p style={{ fontSize: '18px', color: 'black', marginLeft: '30%', marginRight: '15%' }}>
                            Please note that Sr No, Candidate Name, Mobile Number, Email ID, Designation, Total Experience, Relevant Experience and HR Name are required/mandatory fields.<br />
                            Also, if two rows have same emails or contacts only one record would be added or updated.
                        </p>

                        {errorMessagesState && errorMessagesState.length > 0 &&
                            <p style={{ fontSize: '18px', color: 'black', marginLeft: '30%', marginRight: '15%' }}>Please rectify the below errors and re-upload the file.</p>
                        }

                        {errorMessagesState && errorMessagesState.length > 0 &&
                            errorMessagesState.map((errorMessage) => (
                                <>
                                    <p style={{ fontSize: '18px', color: 'red', marginLeft: '30%', marginRight: '15%' }}>{errorMessage}</p>
                                </>
                            ))
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default BulkUpload;
